import React from "react";
import { Link } from "react-router-dom";
import styles from "./NotFound.module.css";
import { FaArrowLeft } from "react-icons/fa";

export default function NotFound() {
  return (
    <div className={styles.notFound}>
      <img
        src="https://cdn-icons-png.flaticon.com/512/616/616408.png"
        alt="Not Found Cat"
        className={styles.catImage}
      />
      <h1 className={styles.title}>404</h1>
      <p className={styles.text}>
        Oops! The page you're looking for doesn't exist.
      </p>
      <Link to="/products" className={styles.btn}>
        <FaArrowLeft /> Back to Dashboard
      </Link>
    </div>
  );
}
